import { Button, ButtonGroup, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Text, useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from 'react-hook-form';
import accept from "../../../../assets/icon/accept.png";
import { instanceRequest } from '../../../../apis/vmRequests.api';
import { GET_REQUESTS } from '../../../../apis/constants.api';
import { STATUS } from '../constant';

export default function AcceptModal(props) {
  const { request, onClose } = props;
  const { userId } = request;
  const queryClient = useQueryClient();
  const { handleSubmit } = useForm();

  const toast = useToast();

  const { mutate: requestAccepted, isLoading } = useMutation({
    mutationFn: (data) => {
      return instanceRequest(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries([GET_REQUESTS]);

      if (data.data.message) {
        toast({
          title: "Success",
          description: data.data.message,
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top-right",
        });
      }
      onClose();
    }
  });

  const onAccept = async () => {
    requestAccepted({ id: request._id, status: STATUS.Approved });
  };

  return (
    <Modal closeOnOverlayClick={false} onClose={onClose} size="lg" isOpen={true} isCentered >
      <form onSubmit={handleSubmit(onAccept)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Image alt='reject' src={accept} />
          </ModalHeader>
          <ModalCloseButton border="1px solid #868B944D" />
          <ModalBody>
            <Text fontSize="fs.18" fontWeight="fw.600">{`Accept ${userId?.name} Instance`}</Text>
            <Text fontSize="fs.14" fontWeight="fw.400" color="#475467" mt="5px" >Do you confirm accepting this instance?</Text>
            <ButtonGroup variant='outline' spacing='5' width="100%" my="18px">
              <Button {...actionButtonChakraProps} onClick={onClose}>Cancel</Button>
              <Button  {...actionButtonChakraProps} type='submit' background={'green.500'} color="white" _hover={{ background: "green.600" }}>
                Accept
                {isLoading && <Spinner size="sm" ml={2} />}
              </Button>
            </ButtonGroup>
          </ModalBody>
        </ModalContent>
      </form>
    </Modal>
  );
}

const actionButtonChakraProps = {
  fontWeight: "fw.600",
  width: "100%",
  borderRadius: "8px",
  height: "44px",
  fontSize: "fs.16",
};